import { Injectable } from '@angular/core';
import { State, Action, StateContext } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services';
import { catchError, map, take } from 'rxjs/operators';
import { ShipmentExportService } from './shipment-export.service';
import { ShipmentExportToFileStart } from './shipment-export.actions';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { NavigateUserService } from '../../../../services/navigate-user.service';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

@State({
  name: 'shipmentExport',
})
@Injectable()
export class ShipmentExportState {
  constructor(
    private shipmentExportService: ShipmentExportService,
    private notificationService: NotificationService,
    private navigateUserService: NavigateUserService,
  ) {}

  @Action(ShipmentExportToFileStart)
  startExportToFile(
    ctx: StateContext<unknown>,
    { payload: { dialogRef, navigationNeeded, ...body } }: ShipmentExportToFileStart,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentExportService.startExportToFile(body).pipe(
      take(1),
      map(() => {
        this.notificationService.success('api.export.success.exportStart');
        dialogRef.close();
        if (navigationNeeded) {
          this.navigateUserService.navigateUserToAbsolutePath('/dashboard/exports');
        }
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }
}
